import React from 'react'
import {findDOMNode} from "react-dom"

import HintPopover from "../hint-popover/hint-popover"
import SelectParent_ValueMulti from "./components/value/multi/multi-value"
import {QuickAddItemType} from "../../../app/quick-add/@types"
import SelectParent_Popover from "./components/popover/popover"
import {SelectParent_Props} from "./@types"
import {CheckboxType} from "../../gd-components/checkbox/checkbox"
import Popover from "../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../gd-components/gd-popover/popover-position"
import {ITreeSelectorParent} from "./components/tree-new/project-tree-new";
import {EntityType} from "../../gd/const/item";

type Props = SelectParent_Props & {
    projectIds?                     : ID[]

    multiselectCheckboxType         : CheckboxType

    inheritedChildrenSelection      : boolean       // should child projects be selected along with parent (inherit selection) or separately (do not inherit selection)
}

type State = {
    values      : ID[]

    showPopover : boolean
}

export default class SelectParentsNew extends React.Component<Props, State> implements ITreeSelectorParent {

    static defaultProps = {
        projectIds                  : [],
        placeholder                 : "Select parent",

        multiselectCheckboxType     : CheckboxType.DEFAULT,
        inheritedChildrenSelection  : true,
        canBeNull                   : false,
    }

    constructor(props: Props) {
        super(props)

        this.state = {
            values      : props.projectIds || [],
            showPopover : false,
        }
    }

    // Interface method
    get parentsFor():EntityType | EntityType[] | undefined {
        return this.props.parentsFor
    }

    get values() {
        return this.state.values
    }

    get multiselect():boolean {
        return true
    }

    get selectedProjects():ID[] {
        return this.values || []
    }

    showPopover = (e: React.SyntheticEvent) => {
        if (this.props.disabled) return

        e.stopPropagation();
        if (!this.state.showPopover) {
            this.setState({
                showPopover: true
            },()=>{
                this.props.onTogglePopover?.(true);
            })
        }
    }

    hidePopover = () => {
        if (this.state.showPopover) {
            this.setState({
                showPopover: false
            }, ()=>{
                this.props.onTogglePopover?.(false)
            })
        }
    }

    onParentSelected = (value: ID | null) => {
        if (_.isNull(value)) {
            this.setState({
                values: []
            }, ()=>{
                this.props.onChange?.([])
                // this.hidePopover()
            })
            return
        }

        const hasProject = this.state.values.includes(value)

        if (hasProject) {
            const selectedProjects = this.state.values.filter((projectId)=>projectId !== value)

            this.setState({
                values: selectedProjects
            }, ()=>{
                this.props.onChange?.(selectedProjects)
            })
        } else {
            const selectedProjects = [...this.state.values, value]

            if (this.props.inheritedChildrenSelection) {
                //remove all children from resulting projects array, they'll have inherited selection
                const clickedProjectChildren = gd.session.projects.get(value)?.childrenProjectsIds
                const alreadySelectedChildrenOfClickedProject = _.intersection(selectedProjects, clickedProjectChildren)
                _.remove(selectedProjects, id=>alreadySelectedChildrenOfClickedProject.includes(id))
            }

            this.setState({
                values: selectedProjects
            }, ()=>{
                this.props.onChange?.(selectedProjects)
            })
        }
    }

    // used when company has no projects
    onNewProjectClick = (e: React.SyntheticEvent) => {
        e.stopPropagation()
        if (this.props.onAddProjectClick) this.props.onAddProjectClick()

        this.hidePopover();
        gd.openNew(QuickAddItemType.PROJECT)
    }

    render() {

        const classes = Classes('gd-select-parent multi-select', this.props.className, 'render-'+this.props.renderType, {
            'not-selected'  : !this.state.values,
            'disabled'      : this.props.disabled,
            'open'          : this.state.showPopover,
            'show-popover'  : this.state.showPopover // required for inline-editable design
        })

        const popoverPosition : PopoverPosition = this.props.popoverPosition || PopoverPosition.bottomCenter() // bottomLeftHorizontal
        const showHint = this.props.hint && !this.state.showPopover

        return (
            <div className={classes} style={this.props.style} onClick={this.showPopover}>
                <SelectParent_ValueMulti parent={this}/>

                {this.state.showPopover &&
                    <Popover  position                = {popoverPosition}
                              className               = "cursor-default border-box"
                              popoverClass            = "gd-select-parent-popover-new"
                              getTargetFunc           = {()=>findDOMNode(this)}
                              outsideClickIgnoreClass = "option"
                              onClickOutside          = {this.hidePopover}>
                        <SelectParent_Popover parentSelector    = {this}
                                              onParentSelected  = {this.onParentSelected}/>
                    </Popover>}

                {showHint &&
                    <HintPopover hint={this.props.hint}/>}
            </div>
        )
    }
}
